export enum SkyconsTypes {
    CLEAR_DAY = 'CLEARDAY',
    CLEAR_NIGHT = 'CLEARNIGHT',
    PARTLY_CLOUDY_DAY = 'PARTLYCLOUDYDAY',
    PARTLY_CLOUDY_NIGHT = 'PARTLYCLOUDYNIGHT',
    CLOUDY = 'CLOUDY',
    RAIN = 'RAIN',
    SLEET = 'SLEET',
    SNOW = 'SNOW',
    WIND = 'WIND',
    FOG = 'FOG'
}